import { ReactComponent as Upload } from '../../../../assets/icons/upload.svg';

export { Upload };
